export default __webpack_public_path__ + "6b93127881fb0246e69713434fbf95b6.svg";